/**
 * Pre-configured axios instance that automatically attaches the admin JWT
 * (stored in localStorage) as an Authorization Bearer header on every request.
 * Import this instead of plain `axios` in all admin-only components.
 */
import axios from 'axios';

const adminAxios = axios.create();

adminAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem('mb-admin-token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On 401, clear stale token so the login page shows
adminAxios.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('mb-admin-token');
      // Let the component handle the redirect
    }
    return Promise.reject(err);
  }
);

export default adminAxios;
